class pressReleaseService {
  async getAllPressReleases(query = "") {
    const baseUrl = useRuntimeConfig().public.API_URL + "/getAllPressReleases";
    const url = query ? `${baseUrl}?${query}` : baseUrl;
    const response = await $fetch(url, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
    return response;
  }

  async getPressReleaseDetail(query) {
    const response = await $fetch(
      useRuntimeConfig().public.API_URL + "/getPressReleaseDetails?" + query,
      { headers: { "Content-Type": "application/json" }, method: "GET" }
    );
    return response;
  }
}

export default new pressReleaseService();
